// Categories & subcategories for Demandes & Problématiques (Orbit)
// Each subcategory can specify:
//   kind: "demande" | "probleme" | "both"  (used to segregate tabs)
//   photo_required: true            (composer opens photo uploader with red required badge)
//   trigger: "..."                  (open a conditional block: recrutement, tenue, disciplinaire, stickers, produit_ha, arret_maladie...)

export const ISSUE_CATEGORIES = {
  ACHAT: {
    label: "Achat", color: "bg-amber-100 text-amber-800 border-amber-300",
    sub: [
      { k: "HA - Produit non conforme", photo_required: true, trigger: "produit_nc", kind: "probleme" },
      { k: "HA - Rupture produit", kind: "probleme", trigger: "produit_ha" },
      { k: "HA - Retard ou pas de livraison", kind: "probleme" },
      { k: "HA - Demande de re-livraison", kind: "demande" },
      { k: "HA - Problème tablette / Scanette", kind: "probleme" },
    ],
  },
  OFFRE_MERCH: {
    label: "Offre & Merch", color: "bg-purple-100 text-purple-800 border-purple-300",
    sub: [
      { k: "OM - Besoin de bande de rive", kind: "demande" },
      { k: "OM - Besoin signalétique / PLV", kind: "demande" },
      { k: "OM - Problème TV", kind: "probleme" },
      { k: "OM - Problème tablette / Scanette", kind: "probleme" },
      { k: "OM - Rupture stickers", kind: "demande", trigger: "stickers" },
      { k: "OM - Problème prix", kind: "probleme", photo_required: true },
      { k: "OM - Demande animation", kind: "demande" },
      { k: "OM - Élément non reçu", kind: "probleme" },
      { k: "OM - Click&Collect", kind: "probleme" },
    ],
  },
  QUALITE: {
    label: "Qualité", color: "bg-blue-100 text-blue-800 border-blue-300",
    sub: [
      { k: "QU - Problème Sato", kind: "probleme" },
      { k: "QU - Besoin formation / Audit", kind: "demande" },
      { k: "QU - Étiquetage", kind: "probleme", photo_required: true },
      { k: "QU - Réclamation", kind: "probleme" },
      { k: "QU - Sécurité", kind: "probleme", photo_required: true },
      { k: "QU - Autres", kind: "probleme" },
    ],
  },
  MAINTENANCE: {
    label: "Maintenance", color: "bg-orange-100 text-orange-800 border-orange-300",
    sub: [
      { k: "MA - Mobilier cassé", photo_required: true, kind: "probleme" },
      { k: "MA - Panne vitrine", kind: "probleme" },
      { k: "MA - Panne machine à riz", kind: "probleme" },
      { k: "MA - Panne frigo / Saladette", kind: "probleme" },
      { k: "MA - Cellule de refroidissement", kind: "probleme" },
      { k: "MA - Meuble wok", photo_required: true, kind: "probleme" },
      { k: "MA - Plonge / Lave-main", photo_required: true, kind: "probleme" },
      { k: "MA - Habillage corner", photo_required: true, kind: "probleme" },
      { k: "MA - Enseigne", photo_required: true, kind: "probleme" },
    ],
  },
  RH: {
    label: "RH", color: "bg-pink-100 text-pink-800 border-pink-300",
    sub: [
      { k: "RH - Recrutement", trigger: "recrutement", kind: "demande" },
      { k: "RH - Absence", kind: "probleme" },
      { k: "RH - Arrêt maladie", photo_required: true, trigger: "arret_maladie", kind: "probleme" },
      { k: "RH - Disciplinaire", trigger: "disciplinaire", kind: "probleme" },
      { k: "RH - Document", kind: "demande" },
      { k: "RH - Problématique d'équipe", kind: "probleme" },
      { k: "RH - Paie / Prime", kind: "demande" },
      { k: "RH - Besoin tenue", trigger: "tenue", kind: "demande" },
    ],
  },
  OPERATION: {
    label: "Opération", color: "bg-emerald-100 text-emerald-800 border-emerald-300",
    sub: [
      { k: "OP - Rupture Top 10 fréquent", photo_required: true, kind: "probleme" },
      { k: "OP - Rupture retail", photo_required: true, kind: "probleme" },
      { k: "OP - Manque de choix", photo_required: true, kind: "probleme" },
      { k: "OP - Report non retiré", photo_required: true, kind: "probleme" },
      { k: "OP - Absence de tenue", kind: "probleme" },
      { k: "OP - Perte exceptionnelle", kind: "probleme" },
      { k: "OP - Alerte hygiène", kind: "probleme", photo_required: true },
      { k: "OP - Prix manquant", photo_required: true, kind: "probleme" },
      { k: "OP - Rangement stock", photo_required: true, kind: "probleme" },
      { k: "OP - Besoin de formation équipe", kind: "demande" },
      { k: "OP - Demande de remontée terrain", kind: "demande" },
    ],
  },
  COMMERCE: {
    label: "Commerce", color: "bg-rose-100 text-rose-800 border-rose-300",
    sub: [
      { k: "CO - Résiliation contrat reçu", kind: "probleme" },
      { k: "CO - Insatisfaction client relevé", kind: "probleme" },
      { k: "CO - Alerte offre concurrence", kind: "probleme" },
      { k: "CO - Renouvellement urgent", kind: "demande" },
      { k: "CO - Difficulté de relation magasin", kind: "probleme" },
      { k: "CO - Demande magasin", kind: "demande" },
    ],
  },
};

export const IMPACTS = [
  "Perte de chiffre d'affaires", "Mauvaise image de marque", "Insatisfaction client",
  "Insatisfaction magasin", "Non conformité / KO audit", "Difficulté pour l'équipe",
  "Risque sécurité", "Baisse de la production", "Aucun impact immédiat", "Autre",
];

export const SERVICE_AFFECTED = [
  { k: "responsable_secteur", label: "Responsable Secteur", color: "bg-blue-500 text-white" },
  { k: "rt_mm", label: "RT/MM", color: "bg-cyan-500 text-white" },
  { k: "dop", label: "DOP", color: "bg-indigo-600 text-white" },
  { k: "dr", label: "Directeur Régional", color: "bg-violet-600 text-white" },
  { k: "commerce", label: "Commerce", color: "bg-rose-500 text-white" },
  { k: "logistique", label: "Logistique", color: "bg-teal-500 text-white" },
  { k: "achat", label: "Achat", color: "bg-amber-500 text-white" },
  { k: "sav_maxime", label: "Maxime (SAV)", color: "bg-slate-600 text-white" },
  { k: "marketing", label: "Marketing", color: "bg-fuchsia-500 text-white" },
  { k: "rh", label: "RH", color: "bg-pink-500 text-white" },
  { k: "offre", label: "Offre", color: "bg-purple-500 text-white" },
  { k: "qualite", label: "Qualité", color: "bg-blue-600 text-white" },
];
export const SERVICE_META = Object.fromEntries(SERVICE_AFFECTED.map(s => [s.k, s]));

export const URGENCY_OPTS = [
  { k: "immediat", label: "Immédiat", days: 0 },
  { k: "24h", label: "-24h", days: 1 },
  { k: "48h", label: "-48h", days: 2 },
  { k: "72h", label: "-72h", days: 3 },
  { k: "7j", label: "-7 jours", days: 7 },
  { k: "15j", label: "-15 jours", days: 15 },
  { k: "30j", label: "-30 jours", days: 30 },
];

export const CONTRACT_TYPES = ["CDI", "CDD", "Intérimaire"];
export const POSTES = ["Chef", "Second", "Commis", "Intérimaire"];
export const HEURES = ["Intérim", "24h", "35h", "37h", "40h"];
export const TENUE_TYPES = ["Veste", "Tablier", "Chaussures", "Casquette", "Pantalon", "Bonnet / Charlotte"];
export const TYPES_UNITE = ["Kg", "Colis", "Unité"];

// Legal-flavored disciplinaire options with sub-descriptions
export const DISCIPLINAIRE_TYPES = [
  { k: "avert_oral", label: "Avertissement oral", legal: "Rappel des règles internes sans inscription au dossier." },
  { k: "avert_ecrit", label: "Avertissement écrit", legal: "Notification écrite conservée au dossier — copie salarié + DRH." },
  { k: "mise_pied_conservatoire", label: "Mise à pied conservatoire", legal: "Suspension immédiate en attente d'une procédure disciplinaire — non punitive." },
  { k: "mise_pied_disciplinaire", label: "Mise à pied disciplinaire", legal: "Suspension avec perte de salaire (1 à 5 jours max)." },
  { k: "convocation_entretien", label: "Convocation entretien préalable", legal: "LRAR sous 5 jours ouvrés minimum avant l'entretien (Art. L1332-2)." },
  { k: "mutation", label: "Mutation disciplinaire", legal: "Nécessite l'accord du salarié si mobilité géographique non prévue au contrat." },
  { k: "retrogradation", label: "Rétrogradation", legal: "Modification du contrat — refus du salarié possible sans faute." },
  { k: "licenciement_faute_simple", label: "Licenciement pour faute simple", legal: "Préavis dû, indemnités dues." },
  { k: "licenciement_faute_grave", label: "Licenciement pour faute grave", legal: "Rupture immédiate — pas de préavis ni indemnité." },
  { k: "licenciement_faute_lourde", label: "Licenciement pour faute lourde", legal: "Intention de nuire — pas de préavis, pas d'indemnité, dommages possibles." },
];

// Marketing stickers — 23 references Sushi & Wok
export const STICKERS_MARKETING = [
  "Wok Bœuf",
  "Wok Poulet",
  "Wok Crevette",
  "Wok Veggie",
  "Madame Wang",
  "À réchauffer",
  "Veggie",
  "Sans poisson cru",
  "Noël",
  "Black Friday",
  "Ouverture",
  "Halloween",
  "-1€",
  "-2€",
  "Anti-gaspi 2€",
  "Anti-gaspi 5€",
  "Anti-gaspi 9€",
  "Anti-gaspi 15€",
  "-50%",
  "Tête de Roy",
  "Nouveauté",
  "Coup de cœur",
  "Click & Collect",
];

// Common produit references for Achat non conforme / Rupture — used as autocomplete hints
export const PRODUIT_HA_HINTS = [
  "Saumon frais", "Thon rouge", "Riz vinaigré", "Feuilles de nori", "Avocat", "Concombre",
  "Sauce soja", "Wasabi frais", "Gingembre mariné", "Wok légumes", "Wok poulet", "Wok bœuf",
  "Sauce teriyaki", "Sauce spicy", "Nouilles udon", "Nouilles soba", "Edamame",
  "Tofu", "Crevettes tempura", "California roll pack", "Maki saumon", "Bento box",
];

export const KIND_META = {
  demande:   { label: "Demandes",       plural: "Demandes",       color: "bg-blue-100 text-blue-800 border-blue-300",  emoji: "📩" },
  probleme:  { label: "Problématiques", plural: "Problématiques", color: "bg-rose-100 text-rose-800 border-rose-300",  emoji: "⚠️" },
};

// Helper: filter categories by kind
export function categoriesForKind(kind) {
  const out = {};
  for (const [k, cat] of Object.entries(ISSUE_CATEGORIES)) {
    const sub = cat.sub.filter(s => !s.kind || s.kind === kind || s.kind === "both");
    if (sub.length) out[k] = { ...cat, sub };
  }
  return out;
}
